<div class="flex-row w-100 m-auto justify-content-center align-items-center" style="display: flex">
  <p class="m-0 p-0 flex-fill text-primary">{{label}}:</p>
  <div ngbDropdown placement="bottom" style="max-width: 50%">
    <button type="button" ngbDropdownToggle class="
        btn btn-sm
        rounded-0
        hs-toolbar-button
        d-flex
        align-items-center
        mw-100
      " aria-haspopup="true" (click)="layersExpanded = !layersExpanded; HsTripPlannerService.fillVectorLayers() "
      [attr.aria-expanded]="layersExpanded">
      <div class="text-truncate" *ngIf="selectedWrapper !== undefined">
        {{selectedWrapper.title | translateHs : {module: 'LAYERS'} }}
      </div>
    </button>
    <div ngbDropdownMenu [ngClass]="{'show': layersExpanded}" style="transform: translateX(25%); width: 15em">
      <div class="d-flex align-items-center w-100 flex-column">
        <a class="dropdown-item text-truncate" *ngFor="let layer of HsTripPlannerService.vectorLayers"
          data-toggle="tooltip" [title]="layer.title | translateHs : {module: 'LAYERS'}"
          (click)="HsTripPlannerService.selectLayer(layer, usage); layersExpanded = false">{{layer.title |
          translateHs : {module: 'LAYERS'} }}</a>
      </div>
    </div>
  </div>
</div>
